const global = {
  API_URL: 'https://agprintersapi.delmarsd.com/Default.aspx',
  //API_URL: 'http://AgPrintersPreview.com/Apps//BigCob/production/',
  COMPANY_ID: 'AgPrintersPreview',
  VERSION: 'production',
  STYLE: '3',
  THEME: '3',
  IS_APP: false,
  log(log) {
    if(false) {
      console.log(log);
    }
  }
};

global.API_URL = 'https://agprintersapi.delmarsd.com/Default.aspx?companyID=' + global.COMPANY_ID + '&version=' + global.VERSION;
export { global };


// WEBPACK FOOTER //
// ./src/global.js